module.exports = __webpack_public_path__ + "static/media/language.30a8d1ff.png";